<template>
  <div class="search-bar">
    <div class="flex-row top-bar">
      <span class="iconfont iconsurvey-outline title">&nbsp;&nbsp; {{ $t('common.searchHistory')}}</span>
      <span class="iconfont icondelete-outline"
        style="font-size: 14px;"
        @click="deleteHistory()"></span>
    </div>
    <van-grid :gutter="10"
      column-num="3">
      <van-grid-item v-for="value in searchList"
        :key="value.id"
        :text="value.content | ellipsis(20)"
        @click="search(value.content)" />
    </van-grid>

  </div>
</template>

<script>
import webService from "../../network/webService";
import _ from "lodash";
import userInfo from "../../common/loginInfo";
import { Dialog } from "vant";
export default {
  name: "SearchBar",
  props: {
    topNum: {
      type: Number,
      default: 6,
    },
    searchType: {
      type: Number,
      default: 1,
    },
  },
  components: {
    Dialog,
  },
  data () {
    return {
      searchList: [],
      userId: userInfo.userToken.userId,
    };
  },
  filters: {
    ellipsis (_val, len) {
      if (!len) {
        len = 21;
      }
      if (!_val) return "";
      if (_val.length > len) {
        return _val.slice(0, len) + "...";
      }
      return _val;
    },
  },
  created () {
    this.loadData();
  },
  methods: {
    loadData () {
      if (this.userId) {
        webService
          .getSearchHistoryList(
            this.userId,
            this.topNum,
            this.searchType
          )
          .then((res) => {
            this.searchList = res.data;
            setTimeout(() => {
              this.$emit("del");
            }, 200);
          });
      }
    },
    deleteHistory () {
      Dialog.confirm({
        //title: '标题',
        message: "确认清除历史搜索记录?",
      })
        .then(() => {
          //确定操作
          webService
            .deleteSearchHistory(this.userId, this.searchType)
            .then(() => {
              this.loadData();
            });
        })
        .catch(() => { });
    },
    search (searchValue) {
      this.$emit("historyClick", searchValue);
    },
  },
};
</script>


<style lang="scss" scoped>
.top-bar {
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  color: #504e4e;
}
.title {
  font-size: 14px;
  //font-weight: 600;
}
/deep/ .van-grid-item__content {
  padding: 4px 4px;
  background-color: #f2f2f2;
  border: 1px solid #dedede;
}
/deep/ .van-grid-item__text {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #7d7d7d;
}
</style>


// WEBPACK FOOTER //
// src/components/common/SearchHistoryBar.vue